import { render, staticRenderFns } from "./credithc.vue?vue&type=template&id=e4a9fc50&scoped=true&"
import script from "./credithc.vue?vue&type=script&lang=js&"
export * from "./credithc.vue?vue&type=script&lang=js&"
import style0 from "./credithc.vue?vue&type=style&index=0&id=e4a9fc50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a9fc50",
  null
  
)

export default component.exports